import Constants from './services/constants/Constants'
/**
 *  If a section is a abstract list
 */
export function isASectionList (section) {
  if (section) {
    if (section.type === 'GENERICS_LIST' ||
              section.type === 'GALLERY' ||
              section.type === 'PLAN' ||
              section.type === 'LIVE') {
      return true
    }
  }
  return false
}

/**
 *  If a section is a map section
 */
export function isASectionPlan (section) {
  if (section) {
    if (section.type === 'PLAN') {
      return true
    }
  }
  return false
}

export function getVideoId (urlYoutube) {
  let param = 'v'
  let result = ''
  let u = urlYoutube
  let reg = new RegExp('(\\?|&|^)'+param+'=(.*?)(&|$)')
  let matches = u.match(reg)
  result = matches[2] !== undefined ? decodeURIComponent(matches[2]).replace(/\+/g, ' ') : ''

  return result
}

export function getThumbnailYoutube (urlYoutube) {
  let result = ''
  if (urlYoutube !== '') {
    let vidId = ''
    if (urlYoutube.startsWith('http://www.youtube') ||
      urlYoutube.startsWith('www.youtube') ||
      urlYoutube.startsWith('https://www.youtube')) {
      vidId = getVideoId(urlYoutube)
      result = 'http://img.youtube.com/vi/' + vidId + '/0.jpg'
    }
  }

  return result
}

export function hasAuth (user, auth) {
  return user.appRights && user.appRights.indexOf(auth) !== -1
}

export function hasAuthorization (user, auth) {
  return user.authorizations && user.authorizations.indexOf(auth) !== -1
}

export function hasUserRight (user, right) {
  return user.userRights && user.userRights.indexOf(right) !== -1
}

export function getSectionAuth () {
  return {
    MAPWIZE: Constants.AppsConstants.USER_RIGHTS.CONTENT.MAPWIZE,
    PLANNER: Constants.AppsConstants.USER_RIGHTS.CONTENT.PLANNER,
    CHAT: Constants.AppsConstants.USER_RIGHTS.CONTENT.CHAT,
    PLUGIN: Constants.AppsConstants.USER_RIGHTS.CONTENT.PLUGIN,
  }
}
